import RootStore from "./rootStore";

const rootStore = new RootStore();

export const stores = {
  rootStore,
  labelerSegmentationStore: rootStore.labelerSegmentationStore,
  labelerSegmentationUiStore: rootStore.labelerSegmentationUiStore,
  fabricSegmentationStore: rootStore.fabricSegmentationStore,
  stickTwoPolygonsStore: rootStore.stickTwoPolygonsStore,
  labelVideoStore: rootStore.labelVideoStore,
  importLabelsStore: rootStore.importLabelsStore,
  analyseStore: rootStore.analyseStore,
};
